module.exports = __webpack_public_path__ + "img/11.e161ff06.jpg";